export default from './SurveySummary';



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerRequestPage/components/SurveySummary/index.js